import api from './api'
import utils from '@/utils/utils'

const ddVoteService = {
  castVote(dealId, verdict, comment = null) {
    const params = { dd_vote: { verdict } }
    if (comment !== null && comment !== undefined) params.dd_vote.comment = comment
    return api.post(`deals/${dealId}/dd_votes`, params)
      .then(response => utils.camelizeKeysDeep(response.data.data))
  },
  removeVote(dealId) {
    return api.delete(`deals/${dealId}/dd_votes`)
      .then(response => utils.camelizeKeysDeep(response.data.data))
  },
}

export default ddVoteService
